// Uncomment the next lines to use your game instance in the browser
// const Game = require('../modules/Game.class');
// const game = new Game();
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.SIZE = 4;
        const empty = ()=>Array.from({
                length: this.SIZE
            }, ()=>Array(this.SIZE).fill(0));
        this._initial = initialState && initialState.length === this.SIZE ? initialState.map((r)=>r.slice()) : empty();
        this.board = this._initial.map((r)=>r.slice());
        this.score = 0;
        this.status = "idle";
        this._won = false;
    }
    /** .
   *
   *
   *
   *
   *
   *                                                                  `
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]\
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ moveLeft() {
        return this._move("left");
    }
    moveRight() {
        return this._move("right");
    }
    moveUp() {
        return this._move("up");
    }
    moveDown() {
        return this._move("down");
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board.map((r)=>r.slice());
    }
    /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ getStatus() {
        return this.status;
    }
    /**
   * Starts the game.
   */ start() {
        if (this.status === "playing") return;
        this.board = this._initial.map((r)=>r.slice());
        this.score = 0;
        this.status = "playing";
        this._won = false;
        if (this._isEmptyBoard(this.board)) {
            this._addRandomTile();
            this._addRandomTile();
        }
        this._updateStatus();
    }
    /**
   * Resets the game.
   */ restart() {
        this.board = this._initial.map((r)=>r.slice());
        this.score = 0;
        this.status = "idle";
        this._won = false;
    }
    _isEmptyBoard(b) {
        return b.flat().every((v)=>v === 0);
    }
    _move(direction) {
        if (this.status !== "playing") return false;
        const prevState = this.getState();
        switch(direction){
            case "left":
                this._moveLeftImpl();
                break;
            case "right":
                this._moveRightImpl();
                break;
            case "up":
                this._moveUpImpl();
                break;
            case "down":
                this._moveDownImpl();
                break;
            default:
                return false;
        }
        const changed = !this._boardsEqual(prevState, this.board);
        if (changed) {
            this._addRandomTile();
            this._updateStatus();
        }
        this._updateStatus();
        if (!this._hasMoves() && this.status === "playing") this.status = "lose";
        return changed;
    }
    _boardsEqual(a, b) {
        return a.flat().every((v, i)=>v === b.flat()[i]);
    }
    _addRandomTile() {
        const empties = [];
        for(let r = 0; r < this.SIZE; r++){
            for(let c = 0; c < this.SIZE; c++)if (this.board[r][c] === 0) empties.push([
                r,
                c
            ]);
        }
        if (empties.length === 0) return;
        const [rr, cc] = empties[Math.floor(Math.random() * empties.length)];
        this.board[rr][cc] = Math.random() < 0.1 ? 4 : 2;
    }
    _updateStatus() {
        if (!this._won && this._hasTarget(2048)) {
            this.status = "win";
            this._won = true;
            return;
        }
        if (this._hasMoves()) {
            if (this.status !== "win") this.status = "playing";
            return;
        }
        if (this.status !== "idle") this.status = "lose";
    }
    _hasTarget(val) {
        return this.board.flat().includes(val);
    }
    _hasMoves() {
        for(let r = 0; r < this.SIZE; r++)for(let c = 0; c < this.SIZE; c++){
            const v = this.board[r][c];
            if (v === 0) return true;
            if (r + 1 < this.SIZE && this.board[r + 1][c] === v) return true;
            if (c + 1 < this.SIZE && this.board[r][c + 1] === v) return true;
        }
        return false;
    }
    _moveLeftImpl() {
        let gained = 0;
        for(let r = 0; r < this.SIZE; r++){
            const row = this.board[r].filter((v)=>v !== 0);
            const merged = [];
            for(let i = 0; i < row.length; i++){
                const curr = row[i];
                const next = row[i + 1];
                if (next && curr === next) {
                    const nv = curr * 2;
                    merged.push(nv);
                    gained += nv;
                    i++;
                } else merged.push(curr);
            }
            while(merged.length < this.SIZE)merged.push(0);
            this.board[r] = merged;
        }
        this.score += gained;
    }
    _moveRightImpl() {
        this.board = this.board.map((row)=>row.slice().reverse());
        this._moveLeftImpl();
        this.board = this.board.map((row)=>row.slice().reverse());
    }
    _moveUpImpl() {
        this.board = this._transpose(this.board);
        this._moveLeftImpl();
        this.board = this._transpose(this.board);
    }
    _moveDownImpl() {
        this.board = this._transpose(this.board);
        this._moveRightImpl();
        this.board = this._transpose(this.board);
    }
    _transpose(b) {
        return b[0].map((_, c)=>b.map((r)=>r[c]));
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$cells = Array.from(document.querySelectorAll(".field-cell"));
const $09e991522ca7e64e$var$scoreEl = document.querySelector(".game-score");
const $09e991522ca7e64e$var$btn = document.querySelector(".button");
const $09e991522ca7e64e$var$msgStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$msgWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$msgLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$field = document.querySelector(".game-field");
const $09e991522ca7e64e$var$cellIndex = (r, c)=>r * 4 + c;
function $09e991522ca7e64e$var$render() {
    const state = $09e991522ca7e64e$var$game.getState();
    for(let r = 0; r < 4; r++)for(let c = 0; c < 4; c++){
        const i = $09e991522ca7e64e$var$cellIndex(r, c);
        const el = $09e991522ca7e64e$var$cells[i];
        const val = state[r][c];
        el.textContent = val === 0 ? "" : String(val);
        el.className = "field-cell";
        if (val) el.classList.add(`field-cell--${val}`);
    }
    $09e991522ca7e64e$var$scoreEl.textContent = String($09e991522ca7e64e$var$game.getScore());
    const gameStatus = $09e991522ca7e64e$var$game.getStatus();
    if (gameStatus === "idle") {
        $09e991522ca7e64e$var$msgStart.classList.remove("hidden");
        $09e991522ca7e64e$var$msgWin.classList.add("hidden");
        $09e991522ca7e64e$var$msgLose.classList.add("hidden");
        $09e991522ca7e64e$var$btn.textContent = "Start";
        $09e991522ca7e64e$var$btn.classList.add("start");
        $09e991522ca7e64e$var$btn.classList.remove("restart");
    } else {
        $09e991522ca7e64e$var$msgStart.classList.add("hidden");
        $09e991522ca7e64e$var$btn.textContent = "Restart";
        $09e991522ca7e64e$var$btn.classList.remove("start");
        $09e991522ca7e64e$var$btn.classList.add("restart");
    }
    if (gameStatus === "win") $09e991522ca7e64e$var$msgWin.classList.remove("hidden");
    else $09e991522ca7e64e$var$msgWin.classList.add("hidden");
    if (gameStatus === "lose") $09e991522ca7e64e$var$msgLose.classList.remove("hidden");
    else $09e991522ca7e64e$var$msgLose.classList.add("hidden");
}
$09e991522ca7e64e$var$btn.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$render();
});
document.addEventListener("keydown", (e)=>{
    const key = e.key;
    if (![
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return;
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    e.preventDefault();
    let moved = false;
    switch(key){
        case "ArrowLeft":
            moved = $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            break;
    }
    if (moved) $09e991522ca7e64e$var$render();
});
let $09e991522ca7e64e$var$startX = 0;
let $09e991522ca7e64e$var$startY = 0;
function $09e991522ca7e64e$var$lockPageScroll() {
    document.body.classList.add("no-scroll");
}
function $09e991522ca7e64e$var$unlockPageScroll() {
    document.body.classList.remove("no-scroll");
}
$09e991522ca7e64e$var$field.addEventListener("mousedown", (e)=>{
    $09e991522ca7e64e$var$startX = e.clientX;
    $09e991522ca7e64e$var$startY = e.clientY;
});
$09e991522ca7e64e$var$field.addEventListener("mouseup", (e)=>{
    $09e991522ca7e64e$var$handleSwipe(e.clientX - $09e991522ca7e64e$var$startX, e.clientY - $09e991522ca7e64e$var$startY);
});
$09e991522ca7e64e$var$field.addEventListener("touchstart", (e)=>{
    const touch = e.changedTouches[0];
    e.preventDefault();
    $09e991522ca7e64e$var$startX = touch.clientX;
    $09e991522ca7e64e$var$startY = touch.clientY;
    $09e991522ca7e64e$var$lockPageScroll();
}, {
    passive: false
});
$09e991522ca7e64e$var$field.addEventListener("touchmove", (e)=>{
    e.preventDefault();
}, {
    passive: false
});
$09e991522ca7e64e$var$field.addEventListener("touchend", (e)=>{
    const touch = e.changedTouches[0];
    e.preventDefault();
    $09e991522ca7e64e$var$handleSwipe(touch.clientX - $09e991522ca7e64e$var$startX, touch.clientY - $09e991522ca7e64e$var$startY);
    $09e991522ca7e64e$var$unlockPageScroll();
}, {
    passive: false
});
$09e991522ca7e64e$var$field.addEventListener("touchcancel", ()=>{
    $09e991522ca7e64e$var$unlockPageScroll();
});
function $09e991522ca7e64e$var$handleSwipe(dx, dy) {
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    if (Math.abs(dx) < 30 && Math.abs(dy) < 30) return;
    let moved = false;
    if (Math.abs(dx) > Math.abs(dy)) moved = dx > 0 ? $09e991522ca7e64e$var$game.moveRight() : $09e991522ca7e64e$var$game.moveLeft();
    else moved = dy > 0 ? $09e991522ca7e64e$var$game.moveDown() : $09e991522ca7e64e$var$game.moveUp();
    if (moved) $09e991522ca7e64e$var$render();
}
$09e991522ca7e64e$var$render();


//# sourceMappingURL=index.9ced43b1.js.map
